import { render } from "./CollectionActivityFeed.vue?vue&type=template&id=7f6091c5"
import script from "./CollectionActivityFeed.vue?vue&type=script&lang=js"
export * from "./CollectionActivityFeed.vue?vue&type=script&lang=js"

import "./CollectionActivityFeed.vue?vue&type=style&index=0&id=7f6091c5&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__